import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import PlatformSection from './components/PlatformSection';
import CategorySection from './components/CategorySection';
import TrendingSection from './components/TrendingSection';
import CollectionSection from './components/CollectionSection';
import ArticleSection from './components/ArticleSection';
import { siteConfig } from '@/mocks/site';

export default function Home() {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: siteConfig.name,
        url: siteConfig.url,
        description: siteConfig.description,
        foundingDate: siteConfig.foundingYear,
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: siteConfig.phone,
          email: siteConfig.email,
          contactType: 'customer service',
        },
        address: {
          '@type': 'PostalAddress',
          streetAddress: siteConfig.address,
          addressCountry: 'CN',
        },
      },
      {
        '@type': 'WebSite',
        name: siteConfig.name,
        url: siteConfig.url,
        description: siteConfig.description,
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: `${siteConfig.url}/search?q={search_term_string}`,
          },
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '首页',
        url: siteConfig.url,
        description: siteConfig.description,
        isPartOf: { '@type': 'WebSite', name: siteConfig.name, url: siteConfig.url },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title={siteConfig.title}
        description={siteConfig.description}
        keywords={siteConfig.keywords}
        canonicalUrl={siteConfig.url}
        schema={homeSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <PlatformSection />
        <CategorySection />
        <TrendingSection />
        <CollectionSection />
        <ArticleSection />
      </main>
      <Footer />
    </>
  );
}